import React from 'react';

export const OPGridTitle = () => (
  <div className='labeled-separator my-2'>
    <div className='labeled-separator__content'>Artworks By Open Platform Artists</div>
  </div>
);
